import {
  QueryKey,
  QueryObserverOptions,
  useQuery,
} from "@tanstack/react-query";
import { LoadState } from "../enum/loading-state";

export default function useCustomQuery<T>(
  queryKey: QueryKey,
  queryFn: () => Promise<T>,
  options?: QueryObserverOptions
) {
  const { fetchStatus, status, data, refetch } = useQuery(
    queryKey,
    () => queryFn(),
    { ...(options as any), keepPreviousData: true }
  );

  let loadState: LoadState;

  if (fetchStatus === "fetching") loadState = LoadState.Loading;
  else {
    switch (status) {
      case "success":
        loadState = LoadState.Success;
        break;

      case "error":
        loadState = LoadState.Error;
        break;

      default:
        loadState = LoadState.Loading;
        break;
    }
  }

  return {
    status: loadState,
    result: data,
    refetch,
  };
}
